import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
export var trackBannerImpression = function trackBannerImpression(visibleText) {
  sendGAEvent({
    event: 'banner_impressions',
    eventCategory: 'Site Wide Banner',
    eventAction: 'Banner Impression',
    eventLabel: visibleText,
    ecommerce: {
      promoView: {
        promotions: [{
          name: visibleText
        }]
      }
    }
  });
};
export var trackBannerClick = function trackBannerClick(evt, visibleText, linkHref) {
  sendGALinkClickEvent(evt, {
    event: 'banner_clicks',
    eventCategory: 'Site Wide Banner',
    eventAction: 'Banner Click',
    eventLabel: visibleText,
    destination_URL: linkHref,
    ecommerce: {
      promoClick: {
        promotions: [{
          name: visibleText,
          id: linkHref
        }]
      }
    }
  });
};